import { render, staticRenderFns } from "./major_possession.vue?vue&type=template&id=3e9e0dd9"
import script from "./major_possession.vue?vue&type=script&lang=js"
export * from "./major_possession.vue?vue&type=script&lang=js"
import style0 from "./major_possession.vue?vue&type=style&index=0&id=3e9e0dd9&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports